import { ChangeDetectionStrategy, Component } from "@angular/core";

import { UiModalOptions } from "../../modal.models";
import { NzModalTitleComponent } from "ng-zorro-antd/modal";
import { TransformModalOptions } from "@webapp/ui/modal/utils/modal.utils";

@Component({
  selector: "div[ui-modal-title]",
  exportAs: "UiModalTitleBuiltin",
  templateUrl: "modal-title.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiModalTitleComponent extends NzModalTitleComponent {
  get title(): string {
    return this.modalConfig?.uiTitle as string;
  }

  constructor(public modalConfig: UiModalOptions) {
    super(TransformModalOptions(modalConfig));
  }
}
